<template>
  <button
    :class="extra"
    class="p-0 w-10 h-10 rounded-full pt-1 active:shadow-lg mouse shadow transition ease-in duration-200 focus:outline-none"
  >
   <box-icon :name="icon" class="fill-current" :size="size"></box-icon>
  </button>
</template>

<script>
export default {
  name: 'IconBtn',
  props: {
    icon: {
      type: String,
      default: 'user'
    },
    size: {
      type: String,
      default: 'sm'
    },
    extra: String
  }
}
</script>

<style>
</style>
